import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { usePermissionContext } from '../../contexts/PermissionContext'
import { LoadingSpinner } from '../ui/LoadingSpinner'

interface OrgAdminRouteProps {
  children: React.ReactNode
}

export const OrgAdminRoute: React.FC<OrgAdminRouteProps> = ({ children }) => {
  const { orgId } = useParams<{ orgId: string }>()
  const { user, isLoading: authLoading } = useAuth()
  const { orgRoleForId, isLoading: permLoading } = usePermissionContext()

  if (authLoading || permLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!user || !orgId) {
    return <Navigate to="/app" replace />
  }

  const role = orgRoleForId(orgId)

  if (!role) {
    return <Navigate to="/app" replace />
  }

  return <>{children}</>
}
